import { combineReducers } from 'redux';
import { fromJS, Map } from 'immutable';
import user from './user/reducer';

function initialized(state = false, action) {
    switch (action.type) {
        case 'APP_INITIALIZED':
            return true;
    }
    return state;
}
function searchCityUrl(state = false, action) {
    switch (action.type) {
        case 'SET_URL_METEO':
            return action.searchCityUrl;
    }
    return state;
}
function configEnvs(state = new Map(), action) {
    switch (action.type) {
        case 'SET_CONFIG_ENVS':
            return fromJS(action.config);
    }
    return state;
}

export default combineReducers({
    user,
    searchCityUrl,
    configEnvs,
    initialized
});



// WEBPACK FOOTER //
// ./data/reducer.js